<template>
  <div class="container">
    <header id="header" class="header">
      <div class="logo-container">
       <a href="http://journey.saatchiis.pl/" alt="">
         <img :src="[sourcesLogo[0]]" v-show="currentPage === 'design'">
         <img :src="[sourcesLogo[1]]" v-show="currentPage === 'creative'">
       </a>
      </div>
      <div class="buttons">
        <div class="internationalization">
          <button @click="changeLang('pl')" class="btn-i18n btn-i18n-pl" :class="{active: lang == 'pl', activeblue: currentPage == 'creative' }">PL</button>
          <button @click="changeLang('en')" class="btn-i18n btn-i18n-en" :class="{active: lang == 'en', activeblue: currentPage == 'creative'}">EN</button>
        </div>
        <router-link :to="{ path: '/'}" replace class="router-link" :class="{activeblue: currentPage == 'creative'}">{{ $t("message.button_home") }}</router-link>
        <router-link :to="{ path: '/contact'}" replace class="router-link" :class="{activeblue: currentPage == 'creative'}">{{ $t("message.button_contact") }}</router-link>
      </div>
    </header>
    <transition name="fade" mode="out-in">
      <router-view :currentPage="currentPage"></router-view>
    </transition>
  </div>
</template>
<script>
  import { EventBus, i18n } from '../main.js';

  export default {
    data: () => ({
      lang: 'en',
      currentPage: 'design',
      sourcesLogo: [
          '../../assets/img/logo.png',
          '../../assets/img/logo-blue.png'
      ]
    }),
    created() {
      EventBus.$on('currentPage', (page)=>{
        this.currentPage = page;
      })
    },
    methods: {
      changeLang(lang) {
        i18n.locale = lang;
        this.lang = lang;
      }
    }
  }

</script>
<style lang="scss">
  body {
    font-family: 'Montserrat', sans-serif;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .container {
    background: black;
  }

  .header {
    display: -webkit-box; 
    display: flex;

    justify-content: space-between;
    -webkit-justify-content: space-between;

    padding: 0 13%;
    box-sizing: border-box;
    .logo-container {
      a {
        display: block;
        cursor: pointer;
      }
    }
  }
  .header .buttons {
    display: -webkit-box;
    display: -ms-flexbox; 
    // display: flex;

    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .header .buttons .router-link-exact-active.router-link-active {
    display: none !important;
  } 
  .header .buttons .router-link {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    writing-mode: tb-rl;
    text-align: right;
    transform: rotateZ(180deg);
    font-size: 14px;
    text-decoration: none;
    color: #998551;
    position: absolute;
    top: 0;
    right: 13%;
    transition: all .3s;
  }
  .header .buttons .router-link:after {
    content: '';
    width: 15px;
    height: 43px;
    background:  url(../../assets/img/arrow.png) no-repeat;
    position: absolute;
    left: 0;
    bottom: 65px;
    transform: rotateZ(180deg);
    transition: all .3s;
  }

  .header .buttons .router-link.activeblue {
    color: #96bbf6;
    transition: all .3s;
  }

  .header .buttons .router-link.activeblue:after {
    background:  url(../../assets/img/arrow-blue.png) no-repeat;
    transition: all .3s;
  }

  .header .buttons .internationalization {
    margin-right: 40px;
  }
  
  .header .buttons .internationalization .btn-i18n {
    cursor: pointer;
    position: relative;
    font-size: 14px;
    text-transform: uppercase;
    border: none;
    background: transparent;
    color: #a2a2a2;
    outline: none;
    transition: all .3s;
  }

  .header .buttons .internationalization .btn-i18n:after {
    content: "";
    width: 16px;
    height: 2px;
    background: transparent;
    position: absolute;
    bottom: -3px;
    left: 15px;
  }
  .header .buttons .internationalization .btn-i18n-en {
    margin-left: 10px;
  }
  
  .header .buttons .internationalization .btn-i18n-en:before {
    content: "";
    width: 2px;
    height: 16px;
    background: #a2a2a2;
    position: absolute;
    top: 0;
    left: -5px;
    display: none;
    @media (min-width: 560px){
      display: inline-block;
    }
  }
  .header .buttons .internationalization .btn-i18n.active {
    display: none;
    @media (min-width: 560px){
      display: inline-block;
    }
  }
  .header .buttons .internationalization .active {
    transition: all .3s;
    color: #998551;
  }

  .header .buttons .internationalization .active:after {
    background: #998551;
  }

  .header .buttons .internationalization .active.activeblue {
    transition: all .3s;
    color: #96bbf6;
  }

  .header .buttons .internationalization .activeblue.active:after {
    background: #96bbf6;
  }

  @media(min-width: 560px) {
    .header .buttons .internationalization .btn-i18n-en {
      margin-left: 28px;
    }

    .header .buttons .internationalization .btn-i18n-en:before {
      left: -14px;
    }
      .header .buttons .internationalization .btn-i18n:after {
      left: 8px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/layout.vue